module.exports = __webpack_public_path__ + "img/gpt-ios-step-4.c5312f54.png";